import EntityDocumentService from '@/Modules/Entity/EntityDocument/EntityDocumentService.js'

export default class EntityDocumentServiceOneDrive extends EntityDocumentService {
  static documentsKey = 'drive-documents'
}
